<script lang="ts">
    import folderIcon from "../assets/folder.svg?raw";
    import { MAX_SOUND_NAME_LENGTH, showToastWrapper } from "../global";

    export let newSoundUploadedCallback: (publicSound: any) => void;

    let files;
    let input;
    let uploading = false;
    let dragging = false;
    let draggingIncorrectFile = false;

    async function performUpload(formData, file) {
        try {
            const response: Response = await fetch(
                `/app/library/upload/sound`,
                {
                    method: "POST",
                    body: formData,
                },
            );
            const publicSound = await response.json();
            if (response.status == 201) {
                newSoundUploadedCallback(publicSound);
                showToastWrapper(`Upload of ${file.name} complete!`);
            }
        } catch (error) {
            console.error(error);
            showToastWrapper(
                "Error uploading. Please try again, and contact support@bardic.tools if it persists.",
                true,
            );
        } finally {
            uploading = false;
        }
    }

    $: if (files) {
        if (files.length > 1) {
            showToastWrapper("Please select only one file");
        }
        uploading = true;
        const file = files[0];
        files = undefined; // We need to set this so that svelte doesn't try to upload more than once
        const formData = new FormData();
        formData.append(input.id, file);

        performUpload(formData, file);
    }

    function stopDrag() {
        dragging = false;
        draggingIncorrectFile = false;
    }

    function handleDrop(evt: DragEvent) {
        evt.preventDefault();
        files = evt.dataTransfer.files;
        stopDrag();
    }
</script>

<label
    class="transition-all-300ms border-solid-2px border-blue border-radius-pico-border-radius padding-1rem full-h center-contents-h font-family-bardic-sans blue background-color-pico-background"
    class:transform-scale-105={dragging}
    on:dragover={(evt) => {
        const items = evt.dataTransfer.items;
        if (items.length === 1 && items[0].type.startsWith("audio/")) {
            dragging = true;
            evt.preventDefault();
        } else {
            draggingIncorrectFile = true;
        }
    }}
    on:dragenter={(evt) => {
        const items = evt.dataTransfer.items;
        if (items.length === 1 && items[0].type.startsWith("audio/")) {
            dragging = true;
        } else {
            draggingIncorrectFile = true;
        }
    }}
    on:dragleave={stopDrag}
    on:dragend={stopDrag}
    on:drop={handleDrop}
>
    {#if uploading}
        <strong>Uploading...</strong>
        <progress style="width: 80%" class="upload-progress" />
    {:else}
        <div class="width-5rem blue">
            {@html folderIcon}
        </div>
        {#if draggingIncorrectFile}
            <span class="pico-color">Not an audio file</span>
        {:else if dragging}
            <span class="pico-color">Drop to upload</span>
        {:else}
            <span class="pico-color">Upload Sound </span>
        {/if}
        <input
            style="display:none"
            bind:files
            accept="audio/*"
            type="file"
            bind:this={input}
            id="new-sound-library"
            name="new-sound-library"
            on:drop={handleDrop}
        />
    {/if}
</label>
